import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/core/account/auth.service';
import { GetDonationDto, GetDonationHistory } from 'src/app/shared/models/get-donation-history.model';
import { DonationService } from 'src/app/shared/services/donation.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { Location } from '@angular/common';
import { MyDonations } from './my-donations.model';
import { IdentityService } from 'src/app/shared/services/identity.service';

@Component({
    selector: 'app-my-donations',
    templateUrl: './my-donations.component.html',
    styleUrls: ['./my-donations.component.scss'],
    standalone: false
})

export class MyDonationsComponent implements OnInit, AfterViewInit {

  isMemberHeader: boolean = true;
  isGivingLoading: boolean = true;
  isLoading: boolean = true;
  result: GetDonationHistory;
  selectedYear: number = new Date().getFullYear();
  selectedType: number = 0;
  data: MyDonations[];

  public memberId: number;

  constructor(private authService: AuthService,
              public globalService: GlobalService,
              private route: ActivatedRoute,
              private _location: Location,
              private _router: Router,  
              private identityService: IdentityService,
              private donationService: DonationService) { }

  async ngOnInit() {
    await this.authService.autoLogin(1);
    this.memberId = this.identityService.memberId;
    this.result = await this.donationService.getDonationsByMember(this.memberId.toString()); 
    this.UpdateView();

    this.isLoading = false;  
    this.isGivingLoading = this.isLoading || (this.isMemberHeader && this.memberId != 0);
  }

  ngAfterViewInit() {
    setTimeout(() => {
    this.globalService.title.push(this.globalService.screenHeader);
    this.globalService.screenHeader = this.globalService.Get('PAYMENT_HISTORY');
    });
  }       

  UpdateView() {
    var filteredSet: any[];
      filteredSet = this.result.donations.filter(a => 
        (this.selectedYear == 0 || a.year == this.selectedYear) &&
        (this.selectedType == 0 || (a.taxDeductible == true && this.selectedType == 1) ||
        (a.taxDeductible == false && this.selectedType == 2)
        )).sort((x,y) => x.chargeDate > y.chargeDate ? -1: 1);
    this.data = filteredSet.map(b =>  { 
      let s: MyDonations = new MyDonations();
      s.donationDate = b.chargeDate;
      s.donationAmount = b.amount;  
  return s;
    });
  }

  CompletedMemberHeader(){
    this.isMemberHeader = false;
    this.isGivingLoading = this.isLoading || (this.isMemberHeader && this.memberId != 0);
  }

  isYearChanged(year) {
    this.selectedYear = parseInt(year);
    this.UpdateView();
  }  

  isTypeChanged(type) {
    this.selectedType = parseInt(type);
    this.UpdateView();
  }
   
  previewStatement() {
    this._router.navigate(['/my-statement/' + this.selectedYear]);
  }  
} 
  